module.exports = __webpack_public_path__ + "img/logo.e50312de.png";